import { render, staticRenderFns } from "./SerialNumberDialog.vue?vue&type=template&id=4cb008c9"
import script from "./SerialNumberDialog.vue?vue&type=script&lang=js"
export * from "./SerialNumberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports